import Vue from 'vue';
import Vuex, {StoreOptions} from 'vuex';
import {RootState} from '@/store/types';
import {auth} from '@/store/auth';
import {config} from '@/store/config';
import {transports} from '@/store/transport';
import {lists} from '@/store/lists';
import {tarification} from "@/store/tarification";
import {smsModule} from "@/store/sms";
import {viberModule} from "@/store/viber";
import {settingsModule} from "@/store/settings";
import {userManagementModule} from "@/store/user_management";
import {rulesModule} from "@/store/rules";
import {finance} from "@/store/finance";
import {callModule} from "@/store/call";
import {pushModule} from "@/store/push";
import {emailModule} from "@/store/email";
import {statistic} from "@/store/statistics";
import {incomingTariffs} from "@/store/tarification/incoming_tariffs"
import {whatsappModule} from "@/store/whatsapp";
import {mailNotifyModule} from "@/store/mail_notify";
import {customModule} from "@/store/custom";
import {cdpModule} from "@/store/cdp";
import router from "@/routes/routes";
import axios from "axios";
import {notifyWarning} from "@/utils/notify-helper";
import Store from "@/store";

axios.interceptors.response.use(response => response,error => {
    switch(error?.response?.status){
        case 204:
            notifyWarning();
            break;
    }
    return Promise.reject(error);
    }
);
Vue.use(Vuex);

const store: StoreOptions<RootState> = {
    plugins: [(store) => {
        store.subscribeAction((action, state) => {
            axios.defaults.headers["Request-Page"] = router.currentRoute.meta.msgKey;
            axios.defaults.headers["Request-Language"] =
                localStorage.getItem('locale') === 'ru' ? 'RUS' : 'ENG';
        })
    }],
    state: {
        isLoading: false,
        isLoadingDetailStat: false,
    },
    getters: {
        isLoading: state => {
            return state.isLoading;
        },
        isLoadingDetailStat: state => {
            return state.isLoadingDetailStat;
        },
    },
    mutations: {
        setLoading: (state, value) => {
            return state.isLoading = value;
        },
        setLoadingDetailStat: (state, value) => {
            return state.isLoadingDetailStat = value;
        },
    },
    actions: {},
    modules: {
        auth,
        config,
        lists,
        transports,
        smsModule,
        pushModule,
        viberModule,
        settingsModule,
        userManagementModule,
        rulesModule,
        tarification,
        finance,
        callModule,
        emailModule,
        whatsappModule,
        mailNotifyModule,
        customModule,
        cdpModule,
        statistic,
        incomingTariffs
    }
};
export default new Vuex.Store<RootState>(store);
